// src/api/http.js
export async function postForm(url, data = {}) {
  const body = new URLSearchParams();
  Object.entries(data).forEach(([k, v]) => {
    if (v !== undefined && v !== null) body.append(k, String(v));
  });

  const res = await fetch(url, {
    method: "POST",
    headers: { Accept: "application/json" },
    credentials: "same-origin",
    body,
  });

  let json = {};
  try { json = await res.json(); } catch (_) {}

  if (json && typeof json.ok === "undefined" && typeof json.status === "string") {
    json.ok = json.status.toUpperCase() === "OK";
  }

  if (!res.ok || (json && json.status && json.status.toUpperCase() === "ERROR")) {
    const msg = (json && json.message) || res.statusText || "Errore operazione";
    throw new Error(msg);
  }

  return json;
}

// (opzionale)
export async function apiGet(url) {
  const r = await fetch(url, { credentials: "same-origin" });
  const j = await r.json().catch(() => ({}));
  if (!r.ok || (j && j.status && j.status.toUpperCase() === "ERROR")) {
    const msg = (j && j.message) || `HTTP ${r.status}`;
    throw new Error(msg);
  }
  if (j && typeof j.ok === "undefined" && typeof j.status === "string") {
    j.ok = j.status.toUpperCase() === "OK";
  }
  return j;
}
